import {
  OnlineBookingClient,
  OnlineBookingClientValidation,
  OnlineBookingPatient,
  OnlineBookingPatientValidation
} from "../../../types";
import { ProvetValidationUtilities } from "../../../utilities";

/**
 * Validates client data and returns validation state.
 * @param client - The client data to validate
 * @returns Validation state for client fields
 */
export function validateClientData(
  client: Partial<OnlineBookingClient>
): OnlineBookingClientValidation {
  return {
    identificationNumberValid: ProvetValidationUtilities.isValidIdentificationNumber(
      client.identificationNumber
    ),
    identificationNumberWarning: false,
    firstNameValid: ProvetValidationUtilities.isValidClientFirstName(client.firstName),
    lastNameValid: ProvetValidationUtilities.isValidClientLastName(client.lastName),
    streetAddressValid: ProvetValidationUtilities.isValidClientStreetAddress(
      client.streetAddress
    ),
    cityValid: ProvetValidationUtilities.isValidClientCity(client.city),
    zipCodeValid: ProvetValidationUtilities.isValidZipCode(client.zipCode)
  };
}

/**
 * Validates patient data and returns validation state.
 * @param patient - The patient data to validate
 * @returns Validation state for patient fields
 */
export function validatePatientData(
  patient: Partial<OnlineBookingPatient>
): Partial<OnlineBookingPatientValidation> {
  return {
    petNameValid: ProvetValidationUtilities.isRequired(patient.name),
    petNotesValid: ProvetValidationUtilities.isValidPatientNotes(patient.notes)
  };
}
